import { Flex, Icon, Text, Tooltip } from "@chakra-ui/react";
import { ComponentType } from "react";
import { Link as RouterLink } from "react-router";

import {
  SIDEBAR_CLOSED_PX,
  SIDEBAR_OPEN_PX,
  SIDEBAR_PADDING_PX,
  SIDEBAR_TRANSITION,
} from "@nens/ranalib";

interface SidebarButtonProps {
  icon: ComponentType<{ color: string }>;
  text: string;
  isActive: boolean;
  isOpen: boolean;
  isDisabled?: boolean;
  disabledTooltip?: string;
  iconShrinkBy?: number;
  onClick?: () => void;
  to?: string;
  href?: string;
}

const iconPadding = 15;
const buttonWidthClosed = SIDEBAR_CLOSED_PX - SIDEBAR_PADDING_PX * 2;
const buttonWidthOpen = SIDEBAR_OPEN_PX - SIDEBAR_PADDING_PX * 2;

export function SidebarButton({
  icon,
  iconShrinkBy = 0,
  text,
  isOpen,
  isDisabled = false,
  disabledTooltip,
  onClick,
  to,
  href,
  isActive,
}: SidebarButtonProps) {
  let color = "white";
  let hoverBg = "brand.sky";
  let bg = "inherit";
  if (isActive) {
    color = "brand.clear_creek_bg";
    hoverBg = "white";
    bg = "white";
  } else if (isDisabled) {
    color = "brand.grey.500";
    hoverBg = "inherit";
  }

  const tooltipIsDisabled = isOpen && !isDisabled;
  let linkProps = {};
  if (to) linkProps = { as: RouterLink, to };
  else if (href) linkProps = { as: "a" as const, href };

  return (
    <Tooltip
      isDisabled={tooltipIsDisabled}
      label={isDisabled ? disabledTooltip ?? text : text}
      placement="right"
      marginLeft={2}
      hasArrow
    >
      <Flex
        {...linkProps}
        rounded="base"
        overflow="hidden"
        alignItems="center"
        w={isOpen ? `${buttonWidthOpen}px` : `${buttonWidthClosed}px`}
        h={`${buttonWidthClosed}px`}
        transition={SIDEBAR_TRANSITION}
        gap={1}
        cursor={isDisabled ? "not-allowed" : "pointer"}
        onClick={(event) => {
          if (isDisabled) {
            event.preventDefault();
            return;
          }
          onClick?.();
        }}
        color={color}
        bg={bg}
        _hover={{
          bg: hoverBg,
        }}
        pl={`${iconPadding / 2 + iconShrinkBy / 2}px`}
      >
        <Icon as={icon} boxSize={`${buttonWidthClosed - iconPadding - iconShrinkBy}px`} />
        {isOpen ? <Text>{text}</Text> : null}
      </Flex>
    </Tooltip>
  );
}
